/* KrakenTheMeta dashboard — the deck builder (#/deck/<id>).
 * The deck and its numbers on the left, one panel to add cards on the right (search, AI, import);
 * on phones the three are tabs. Every edit writes straight to Firestore, and a published deck
 * offers "Update public page" once it has changed since it was published.
 */
(function () {
  "use strict";

  var KD = window.KD, S = KD.state, D = KD.data, esc = KD.esc;

  // One-shot hand-offs from other views, read once when a deck opens:
  // pendingResult (a finished AI build), pendingImport (a list pasted in the new-deck sheet),
  // openTool ("search" | "ai" | "import") and retry ({ prompt } after a failed build).
  var B = (KD.builder = KD.builder || {});
  B.deckId = null;
  // What the improve module (55-improve.js) needs from the open deck. Read live, so it always
  // talks to the deck on screen.
  B.host = {
    deck: function () { return ctx && ctx.loaded ? ctx.deck : null; },
    cards: function () { return ctx ? ctx.cards : []; },
    settle: function () { return ctx ? ctx.q : Promise.resolve(); },
    reload: function () { return ctx ? reloadCards(ctx) : Promise.resolve(); },
    edited: function () { if (ctx) edited(); },
    strip: function (o) {
      var host = $("[data-strip]");
      if (!host) return;
      host.innerHTML = strip({ kind: o.kind, title: esc(o.title), text: esc(o.text), notes: o.notes || [], cta: o.cta || "" });
      var b = o.onCta && KD.$(".strip .btn", host);
      if (b) b.addEventListener("click", function () { host.innerHTML = ""; o.onCta(); });
    }
  };

  var COLOR_HEX = { W: "#efe0a8", U: "#4c9be8", B: "#9a84c4", R: "#e5645a", G: "#43c28b", C: "#9aa7b5" };
  var COLOR_NAME = { W: "White", U: "Blue", B: "Black", R: "Red", G: "Green", C: "Colorless only" };
  var TYPES = ["Creature", "Instant", "Sorcery", "Artifact", "Enchantment", "Planeswalker", "Land", "Battle"];
  var PRESETS = [
    { label: "Most played", q: "game:paper", sort: "edhrec" },
    { label: "Removal", q: "otag:removal" },
    { label: "Card draw", q: "otag:card-advantage" },
    { label: "Ramp", q: "otag:ramp" },
    { label: "Board wipes", q: "otag:board-wipe" },
    { label: "Counterspells", q: "otag:counterspell" },
    { label: "Dual lands", q: "t:land otag:dual-land" }
  ];

  var ctx = null; // the open deck

  function $(s) { return ctx && ctx.root ? KD.$(s, ctx.root) : null; }
  function $$(s) { return ctx && ctx.root ? KD.$$(s, ctx.root) : []; }
  function qty(c) { return parseInt(c.quantity, 10) || 1; }
  function publicId() { return ctx && S.published ? S.published[ctx.deck.id] || null : null; }
  function publicUrl(pid) { return (KD.SITE || location.origin) + "/deck-view?deckId=" + encodeURIComponent(pid); }
  function inDeck(name) { return ctx.cards.reduce(function (n, c) { return n + (c.name === name ? qty(c) : 0); }, 0); }
  function findCard(id) { return ctx.cards.find(function (c) { return String(c.id) === String(id); }); }
  function priceText(c) { var p = parseFloat(c.price); return isNaN(p) ? "" : "$" + p.toFixed(2); }
  function frontCost(cost) { return String(cost || "").split("//")[0]; }
  function viewPref() { try { return localStorage.getItem("kd_deck_view") === "cards" ? "cards" : "list"; } catch (e) { return "list"; } }
  function upsellQuiet() { try { return Number(localStorage.getItem("kd_success_upsell_until") || 0) > Date.now(); } catch (e) { return false; } }

  // Writes run one at a time per deck, so fast taps on "+" count correctly.
  function enqueue(fn) {
    var my = ctx;
    my.q = my.q.then(fn).catch(function (e) { console.error("deck write", e); KD.toast("That change didn't save. Try again.", "err"); });
    return my.q;
  }

  // ================================================================ route

  KD.routes.deck = async function (view, id) {
    B.deckId = id || null;
    var my = (ctx = {
      deck: null, cards: [], loaded: false, root: null, view: viewPref(), tab: "deck", tool: "search", stale: false, nudged: false,
      q: Promise.resolve(), touchT: null, peekRow: null,
      search: { q: "", colors: new Set(), colorsTouched: false, type: "", mv: "", sort: "", legal: true, buf: [], shown: 0, next: null, total: 0, token: 0, cache: {} }
    });
    view.innerHTML = '<div class="bhero skel" aria-hidden="true"></div><div class="bgrid"><div class="panel skel" style="height:360px"></div></div>';
    try {
      var deck = id ? await D.fetchDeck(id) : null;
      if (ctx !== my) return;
      if (!deck) {
        view.innerHTML = '<div class="empty">' + KD.icon("layers") + "<h3>That deck isn't here</h3><p>It may have been deleted, or the link belongs to another account.</p>" +
          '<a class="btn btn--ghost" href="#/decks">' + KD.icon("left") + "Back to your decks</a></div>";
        return;
      }
      my.deck = deck;
      view.innerHTML = shell();
      my.root = KD.$("[data-builder]", view);
      bind(my.root);
      paintHeader();
      paintAdd();
      setTab("deck");
      try { my.cards = await D.getDeckCards(id); }
      catch (e) {
        console.error("deck cards", e);
        if (ctx === my) $('[data-pane="deck"]').innerHTML = '<div class="empty">' + KD.icon("alert") + "<h3>Couldn't load this deck</h3><p>Check your connection and refresh the page.</p></div>";
        return;
      }
      if (ctx !== my) return;
      await migrateInline(my);
      my.loaded = true;
      await D.loadPublished().catch(function () {});
      if (ctx !== my) return;
      defaultSearchColors();
      paintAll();
      if (ctx.tool === "search") paintTool();
      checkStale(my);
      D.healDeckCards(id, my.cards).then(function (n) {
        if (n && ctx === my) { paintAll(); KD.toast("Repaired the card data for " + n + " " + KD.plural(n, "card") + ".", "ok"); }
      }).catch(function () {});
      handoffs();
    } catch (e) {
      console.error("builder", e);
      if (ctx === my) view.innerHTML = '<div class="empty">' + KD.icon("alert") + "<h3>Something went wrong</h3><p>Refresh the page to try again.</p>" +
        '<a class="btn btn--ghost" href="#/decks">Back to your decks</a></div>';
    }
  };

  window.addEventListener("hashchange", function () {
    if (KD.parseRoute().name !== "deck") { B.deckId = null; ctx = null; unpeek(); }
  });

  function shell() {
    var d = ctx.deck;
    return '<div class="builder" data-builder>' +
      '<section class="bhero">' +
        '<div class="bhero__art" data-art></div>' +
        '<a class="bhero__back" href="#/decks">' + KD.icon("left") + "Decks</a>" +
        '<div class="bhero__main">' +
          '<div class="bhero__title"><h2><span data-name>' + esc(d.name) + "</span>" +
            '<button class="iconbtn iconbtn--sm" type="button" data-rename aria-label="Rename deck" title="Rename">' + KD.icon("pen") + "</button></h2></div>" +
          '<div class="bhero__meta"><span class="badge">' + esc(D.formatLabel(d.format)) + '</span><span class="bhero__count" data-count></span><span class="mono muted" data-price></span><span data-pub></span></div>' +
        "</div>" +
        '<div class="bhero__actions" data-actions></div>' +
      "</section>" +
      "<div data-strip></div>" +
      '<div class="btabs"><div class="seg seg--block" role="tablist" aria-label="Deck builder">' +
        '<button type="button" role="tab" data-tab="deck">' + KD.icon("layers") + "<span data-tabcount>Deck</span></button>" +
        '<button type="button" role="tab" data-tab="add">' + KD.icon("plus") + "<span>Add cards</span></button>" +
        '<button type="button" role="tab" data-tab="stats">' + KD.icon("chart") + "<span>Stats</span></button>" +
      "</div></div>" +
      '<div class="bgrid">' +
        '<section class="panel dstats" data-pane="stats" aria-label="Deck stats"></section>' +
        '<section class="panel dlist" data-pane="deck" aria-label="Cards in this deck"><div class="rskel skel"></div><div class="rskel skel"></div><div class="rskel skel"></div><div class="rskel skel"></div></section>' +
        '<section class="panel addp" data-pane="add" aria-label="Add cards"></section>' +
      "</div></div>";
  }

  function handoffs() {
    if (B.pendingResult) { var r = B.pendingResult; B.pendingResult = null; showResult(r); }
    if (B.pendingImport) {
      var p = B.pendingImport; B.pendingImport = null;
      var after = B.improvePreset; B.improvePreset = null;
      runImport(p).then(function (ok) {
        if (!ok || !ctx) return;
        if (after) { openImprove(after); return; }
        if (D.deckStats(ctx.cards).total >= 10) B.host.strip({
          kind: "info", title: "Your list is in",
          text: "Want suggestions? The Kraken can swap your weakest cards for better ones, and you pick which swaps to keep.",
          cta: '<button class="btn btn--lure btn--sm" type="button">' + KD.icon("wand") + "<span>Improve it with AI</span></button>",
          onCta: function () { openImprove(null); }
        });
      });
    } else if (B.improvePreset) { var pr = B.improvePreset; B.improvePreset = null; openImprove(pr); }
    if (B.retry) { setTab("add"); setTool("ai"); }
    if (B.openTool) {
      var t = B.openTool; B.openTool = null;
      setTab("add"); setTool(t);
      if (t === "search") { var i = $("[data-sq]"); if (i) try { i.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
    }
  }

  // Very old decks kept their cards inline on the deck doc; move them into the cards subcollection
  // once so every edit works like any other deck.
  async function migrateInline(my) {
    if (!my.cards.some(function (c) { return String(c.id).indexOf("inline-") === 0; })) return;
    try {
      var db = window.db || firebase.firestore(), batch = db.batch(), ops = 0, pairs = [];
      for (var i = 0; i < my.cards.length; i++) {
        var c = my.cards[i], ref = D.cardsRef(my.deck.id).doc();
        batch.set(ref, D.toShape(c, qty(c), !!c.isCommander));
        pairs.push([c, ref.id]);
        if (++ops >= 400) { await batch.commit(); batch = db.batch(); ops = 0; }
      }
      if (ops) await batch.commit();
      pairs.forEach(function (p) { p[0].id = p[1]; });
    } catch (e) { console.warn("inline deck migrate", e); }
  }

  // A published deck is stale when it was edited after its public copy was last written.
  async function checkStale(my) {
    if (!publicId()) return;
    try {
      var r = await Promise.all([D.pubMapRef().doc(my.deck.id).get(), D.deckRef(my.deck.id).get()]);
      var upd = KD.toDate((r[0].data() || {}).updatedAt), mod = KD.toDate((r[1].data() || {}).lastModified);
      if (ctx === my && upd && mod && mod.getTime() - upd.getTime() > 5000) { my.stale = true; paintActions(); }
    } catch (e) { /* the button just won't show */ }
  }

  function edited() {
    var my = ctx, id = my.deck.id;
    clearTimeout(my.touchT);
    my.touchT = setTimeout(function () { my.touchT = null; D.touchDeck(id); }, 1200);
    var cached = (S.decks || []).find(function (d) { return d.id === id; });
    if (cached) { cached._sort = Date.now(); S.decks.sort(function (a, b) { return b._sort - a._sort; }); }
    if (publicId() && !my.stale) { my.stale = true; paintActions(); }
  }
  async function flushTouch() {
    if (!ctx.touchT) return;
    clearTimeout(ctx.touchT); ctx.touchT = null;
    await D.touchDeck(ctx.deck.id);
  }

  // Commander decks search inside the commander's colors until the user picks colors themselves.
  function defaultSearchColors() {
    var s = ctx.search;
    if (s.colorsTouched || !D.isCommanderFormat(ctx.deck.format)) return;
    var cmds = ctx.cards.filter(function (c) { return c.isCommander && c.imageUrl; });
    if (!cmds.length) return;
    var ids = new Set();
    cmds.forEach(function (c) { (c.colorIdentity || []).forEach(function (x) { if (COLOR_HEX[x]) ids.add(x); }); });
    s.colors = ids.size ? ids : new Set(["C"]);
  }

  // ================================================================ events

  function bind(root) {
    root.addEventListener("click", onClick);
    root.addEventListener("mouseover", peek);
    root.addEventListener("mouseout", function (e) {
      var row = e.target.closest(PEEK_SEL);
      if (row && !row.contains(e.relatedTarget)) unpeek();
    });
  }

  function onClick(e) {
    var t = e.target, el;
    if ((el = t.closest("[data-act]"))) { e.preventDefault(); onAction(el.dataset.act, el); return; }
    if (t.closest("[data-rename]")) { rename(); return; }
    if ((el = t.closest("[data-tab]"))) { setTab(el.dataset.tab); return; }
    if ((el = t.closest("[data-tool]"))) { setTool(el.dataset.tool); return; }
    if ((el = t.closest("[data-tool-go]"))) {
      setTab("add"); setTool(el.dataset.toolGo);
      var i = el.dataset.toolGo === "search" && $("[data-sq]"); if (i) i.focus();
      return;
    }
    if ((el = t.closest("[data-view]"))) {
      ctx.view = el.dataset.view;
      try { localStorage.setItem("kd_deck_view", ctx.view); } catch (err) { /* ignore */ }
      paintDeck();
      return;
    }
    if ((el = t.closest("[data-card]"))) { var c = findCard(el.dataset.card); if (c) { unpeek(); openCard(c); } return; }
    if ((el = t.closest("[data-add]"))) { var row = el.closest("[data-sid]"); addFromSearch(ctx.search.cache[row.dataset.sid], el); return; }
    if ((el = t.closest("[data-peek]"))) { var r2 = el.closest("[data-sid]"); unpeek(); openScry(ctx.search.cache[r2.dataset.sid]); return; }
    if ((el = t.closest("[data-preset]"))) {
      var p = PRESETS[+el.dataset.preset], s = ctx.search;
      s.q = p.q; s.sort = p.sort || s.sort; s.buf = [];
      paintTool();
      return;
    }
    if ((el = t.closest("[data-color]"))) { toggleColor(el.dataset.color); return; }
    if (t.closest("[data-legal]")) {
      var st = ctx.search; st.legal = !st.legal;
      var chip = $("[data-legal]"); chip.classList.toggle("is-on", st.legal); chip.setAttribute("aria-pressed", String(st.legal));
      if (st.q.trim()) runSearchSoon(0);
      return;
    }
    if ((el = t.closest("[data-more]"))) { loadMore(el); return; }
    if (t.closest("[data-upsell-go]")) { KD.ga("success_upsell_clicked"); return; }
    if ((el = t.closest("[data-strip-x]"))) {
      var strip = el.closest(".strip");
      if (strip && strip.hasAttribute("data-upsell")) {
        try { localStorage.setItem("kd_success_upsell_until", String(Date.now() + 7 * 864e5)); } catch (err) { /* ignore */ }
        KD.ga("success_upsell_dismissed");
      }
      if (strip) strip.remove();
    }
  }

  function onAction(act, el) {
    if (act === "publish") publishFlow();
    else if (act === "sync") syncPublic();
    else if (act === "share") share();
    else if (act === "name") aiName();
    else if (act === "more") moreMenu(el);
    else if (act === "analyze") analyze();
  }

  function setTab(t) {
    ctx.tab = t;
    $$("[data-tab]").forEach(function (b) { b.setAttribute("aria-selected", String(b.dataset.tab === t)); });
    $$("[data-pane]").forEach(function (p) { p.hidden = p.dataset.pane !== t; });
  }

  // "/" jumps to card search from anywhere in the builder
  document.addEventListener("keydown", function (e) {
    if (!ctx || !ctx.root || e.key !== "/" || e.metaKey || e.ctrlKey || e.altKey) return;
    var t = e.target;
    if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
    if (document.querySelector(".sheet")) return;
    e.preventDefault();
    setTab("add");
    if (ctx.tool !== "search") setTool("search");
    var i = $("[data-sq]"); if (i) i.focus();
  });

  // ================================================================ header

  function paintAll() { paintHeader(); paintDeck(); paintStats(); refreshBadges(); }

  function paintHeader() {
    var d = ctx.deck, st = D.deckStats(ctx.cards), target = D.targetSize(d.format);
    $("[data-name]").textContent = d.name;
    KD.setTitle(d.name || "Deck");
    $("[data-count]").innerHTML = !ctx.loaded ? "<span>Loading cards…</span>" : "<span><b>" + st.total + "</b> / " + target + " cards</span>" +
      '<span class="meter' + (st.total > target ? " is-over" : "") + '"><i style="width:' + Math.min(100, Math.round(st.total / target * 100)) + '%"></i></span>';
    $("[data-price]").textContent = st.priced ? "≈ " + KD.money(st.price) : "";
    $("[data-pub]").innerHTML = publicId() ? '<span class="badge badge--glow">' + KD.icon("globe") + "Public</span>" : "";
    var tc = $("[data-tabcount]"); if (tc) tc.textContent = "Deck · " + st.total;
    var hdr = D.pickHeaderCard(ctx.cards), art = $("[data-art]");
    var u = hdr ? KD.safeUrl(D.artUrl(hdr)) : "";
    art.style.backgroundImage = u ? 'url("' + u.replace(/"/g, "%22") + '")' : "";
    // keep the library tile (count + art) in step with the deck
    if (ctx.loaded) {
      if (st.total !== d.cardCount || (hdr && hdr !== d.headerImage)) {
        var meta = { cardCount: st.total };
        if (hdr) meta.headerImage = hdr;
        d.cardCount = st.total;
        if (hdr) d.headerImage = hdr;
        D.saveDeckMeta(d.id, meta);
      }
    }
    paintActions();
  }

  function paintActions() {
    var host = $("[data-actions]");
    if (!host) return;
    if (!ctx.loaded) { host.innerHTML = ""; return; }
    var pid = publicId(), h = "";
    if (pid && ctx.stale) h += '<button class="btn btn--lure btn--sm" type="button" data-act="sync">' + KD.icon("refresh") + "<span>Update public page</span></button>";
    if (!pid) h += '<button class="btn btn--ghost btn--sm" type="button" data-act="publish">' + KD.icon("globe") + "<span>Publish</span></button>";
    if (pid) {
      h += '<a class="btn btn--ghost btn--sm" href="' + esc(publicUrl(pid)) + '" target="_blank" rel="noopener">' + KD.icon("eye") + "<span>View</span></a>";
      h += '<button class="iconbtn iconbtn--line" type="button" data-act="share" aria-label="Share link" title="Share link">' + KD.icon("share") + "</button>";
    }
    h += '<button class="iconbtn iconbtn--line" type="button" data-act="name" aria-label="Name it with AI" title="Name it with AI">' + KD.icon("wand") + "</button>";
    h += '<button class="iconbtn iconbtn--line" type="button" data-act="more" aria-label="More deck options" title="More">' + KD.icon("dots") + "</button>";
    host.innerHTML = h;
  }

  function moreMenu(anchor) {
    var has = ctx.cards.length > 0, pid = publicId();
    var items = [
      { label: "Rename", icon: "pen", onClick: rename },
      { label: "Name it with AI", icon: "wand", onClick: aiName },
      { label: "Change format", icon: "tag", onClick: changeFormat }
    ];
    if (has) {
      items.push("sep",
        { label: "Copy decklist", icon: "copy", onClick: function () { KD.copy(listText(), "Decklist copied."); } },
        { label: "Download as .txt", icon: "download", onClick: exportTxt },
        { label: "Buy on TCGplayer", icon: "cart", href: buyDeckUrl(), external: true },
        { label: "Analyze this deck", icon: "chart", onClick: analyze });
    }
    if (pid && S.isPremium) items.push("sep", { label: "Remove from the gallery", icon: "globe", onClick: unpublish });
    items.push("sep", { label: "Delete deck", icon: "trash", danger: true, onClick: function () { KD.deleteDeckFlow(ctx.deck, function () { KD.go("decks"); }); } });
    KD.menu(anchor, items, ctx.deck.name);
  }

  async function rename() {
    var my = ctx;
    var n = await KD.ask({ title: "Rename deck", label: "Deck name", value: my.deck.name, max: 80 });
    if (!n || n === my.deck.name || ctx !== my) return;
    try { await D.setDeckName(my.deck.id, n); my.deck.name = n; if (ctx === my) { paintHeader(); edited(); } KD.toast("Renamed.", "ok"); }
    catch (e) { KD.toast("Rename failed. Try again.", "err"); }
  }

  async function aiName() {
    var my = ctx;
    if (!my.cards.length) { KD.toast("Add some cards first, then the Kraken can name it.", "info"); return; }
    KD.busy("Thinking up a name…");
    try {
      var cmd = my.cards.filter(function (c) { return c.isCommander; }).map(function (c) { return c.name; }).join(" + ");
      var n = await D.aiName(my.cards, { commander: cmd || null, format: D.formatLabel(my.deck.format) });
      KD.idle();
      if (!n) { KD.toast("Couldn't come up with a name. Try again.", "err"); return; }
      await D.setDeckName(my.deck.id, n);
      my.deck.name = n;
      if (ctx === my) { paintHeader(); edited(); }
      KD.toast("Named “" + n + "”.", "ok");
    } catch (e) { console.error(e); KD.idle(); KD.toast("Naming failed. Try again.", "err"); }
  }

  function changeFormat() {
    var my = ctx, cur = String(my.deck.format || "").toLowerCase();
    var s = KD.sheet({
      title: "Change format",
      body: '<p class="hint">Sets the deck size, what card search treats as legal, and the rules the AI builds to. Cards already in the deck stay.</p>' +
        '<div class="chips mt-16" style="flex-wrap:wrap">' + D.FORMATS.map(function (f) {
          return '<button class="chip' + (f[0] === cur ? " is-on" : "") + '" type="button" data-fmt="' + f[0] + '">' + f[1] + "</button>";
        }).join("") + "</div>"
    });
    KD.$$("[data-fmt]", s.el).forEach(function (b) {
      b.addEventListener("click", async function () {
        var f = b.dataset.fmt;
        s.close();
        if (f === cur) return;
        try {
          await D.deckRef(my.deck.id).update({ format: f, lastModified: firebase.firestore.FieldValue.serverTimestamp() });
          my.deck.format = f;
          var cached = (S.decks || []).find(function (x) { return x.id === my.deck.id; });
          if (cached) cached.format = f;
          KD.toast("Now a " + D.formatLabel(f) + " deck.", "ok");
          if (ctx === my) KD.router();
        } catch (e) { KD.toast("Couldn't change the format.", "err"); }
      });
    });
  }

  // ---- publishing
  async function publishFlow() {
    var my = ctx;
    if (!my.cards.length) { KD.toast("Add some cards before publishing.", "info"); return; }
    var ok = await KD.confirm({
      title: "Publish to the gallery?",
      body: "<p>Your deck gets a public page anyone can find, like and copy. Keep editing it here and update the page whenever you like.</p>",
      confirm: "Publish"
    });
    if (!ok || ctx !== my) return;
    KD.busy("Publishing…");
    try {
      await flushTouch();
      await D.publishDeck(my.deck.id);
      my.stale = false;
      KD.idle();
      KD.ga("deck_publish", { format: my.deck.format });
      KD.toast("Published. Your deck is live.", "ok");
      if (ctx === my) { paintHeader(); var st = $(".strip [data-act='publish']"); if (st) st.closest(".strip").remove(); }
    } catch (e) { console.error(e); KD.idle(); KD.toast("Publishing failed. Try again.", "err"); }
  }

  async function syncPublic() {
    var my = ctx;
    KD.busy("Updating the public page…");
    try {
      await flushTouch();
      await D.publishDeck(my.deck.id);
      my.stale = false;
      KD.idle();
      KD.toast("Public page updated.", "ok");
      if (ctx === my) paintHeader();
    } catch (e) { console.error(e); KD.idle(); KD.toast("Couldn't update the public page. Try again.", "err"); }
  }

  async function unpublish() {
    var my = ctx;
    var ok = await KD.confirm({
      title: "Remove it from the gallery?",
      body: "<p>The public page, with its likes and views, is removed. The deck stays here, private, and you can publish it again anytime.</p>",
      confirm: "Remove public page", danger: true
    });
    if (!ok) return;
    KD.busy("Removing the public page…");
    try { await D.unpublishDeck(my.deck.id); my.stale = false; KD.idle(); if (ctx === my) paintHeader(); KD.toast("The deck is private again.", "ok"); }
    catch (e) { console.error(e); KD.idle(); KD.toast("Couldn't remove the public page. Try again.", "err"); }
  }

  async function share() {
    var pid = publicId();
    if (!pid) return;
    var url = publicUrl(pid);
    if (navigator.share && KD.mobile()) { try { await navigator.share({ title: ctx.deck.name, url: url }); } catch (e) { /* cancelled */ } return; }
    KD.copy(url, "Link copied.");
  }

  // ---- export + hand-offs
  function listText() {
    var cats = D.categorize(ctx.cards), lines = [];
    Object.keys(cats).forEach(function (k) { cats[k].forEach(function (c) { if (c.name) lines.push(qty(c) + " " + c.name); }); });
    return lines.join("\n");
  }
  function exportTxt() {
    var name = (ctx.deck.name || "deck").replace(/[^a-z0-9]+/gi, "_").replace(/^_|_$/g, "").toLowerCase() || "deck";
    KD.download(name + ".txt", listText() + "\n");
  }
  function buyDeckUrl() {
    var cards = ctx.cards.filter(function (c) { return c.name; }).map(function (c) { return { name: c.name, qty: qty(c) }; });
    return window.KTM_AFF ? window.KTM_AFF.deckLink(cards, "Magic") : "https://www.tcgplayer.com/massentry";
  }
  // The analyzer picks up kraken_pending_analysis and runs on it. Only a real list travels.
  function analyze() {
    var list = ctx && ctx.cards.length ? listText() : "";
    if (list) try { localStorage.setItem("kraken_pending_analysis", list); } catch (e) { /* private mode: it opens empty */ }
    location.href = KD.SITE + "/mtg-deck-analyzer";
  }

  // ================================================================ the deck

  function paintDeck() {
    var host = $('[data-pane="deck"]');
    if (!host) return;
    var cards = ctx.cards, st = D.deckStats(cards);
    var bar = '<div class="dlist__bar"><span class="label">' + st.total + " " + KD.plural(st.total, "card") + " · " + cards.length + " unique</span>" +
      '<div class="seg" role="tablist" aria-label="Show cards as">' +
        '<button type="button" role="tab" data-view="list" aria-selected="' + (ctx.view === "list") + '">' + KD.icon("list") + '<span class="hide-sm">List</span></button>' +
        '<button type="button" role="tab" data-view="cards" aria-selected="' + (ctx.view === "cards") + '">' + KD.icon("grid") + '<span class="hide-sm">Cards</span></button>' +
      "</div></div>";
    if (!cards.length) {
      host.innerHTML = '<div class="empty">' + KD.icon("layers") + "<h3>This deck is empty</h3><p>Search for cards, paste a list, or let the Kraken build the whole thing.</p>" +
        '<div class="row row--wrap" style="justify-content:center">' +
          '<button class="btn btn--ghost btn--sm" type="button" data-tool-go="search">' + KD.icon("search") + "Search cards</button>" +
          '<button class="btn btn--ghost btn--sm" type="button" data-tool-go="import">' + KD.icon("download") + "Paste a list</button>" +
          '<button class="btn btn--lure btn--sm" type="button" data-tool-go="ai">' + KD.icon("sparkle") + "Build it with AI</button>" +
        "</div></div>";
      return;
    }
    var cats = D.categorize(cards);
    host.innerHTML = bar + Object.keys(cats).filter(function (k) { return cats[k].length; }).map(function (k) {
      var arr = cats[k], n = arr.reduce(function (s, c) { return s + qty(c); }, 0);
      var label = k === "Commander" && arr.length > 1 ? "Commanders" : k;
      return '<div class="dgroup"><h4>' + label + " <span>" + n + "</span></h4>" +
        (ctx.view === "cards" ? '<div class="dcards">' + arr.map(cardTile).join("") + "</div>" : arr.map(cardRow).join("")) + "</div>";
    }).join("");
  }

  function cardRow(c) {
    return '<button type="button" class="drow' + (c.isCommander ? " is-cmd" : "") + '" data-card="' + esc(c.id) + '">' +
      '<span class="drow__qty">' + qty(c) + "×</span>" +
      '<span class="drow__name">' + (c.isCommander ? KD.icon("crown") : "") + "<span>" + esc(c.name) + "</span></span>" +
      '<span class="drow__cost">' + KD.mana(frontCost(c.manaCost)) + "</span>" +
      '<span class="drow__price">' + priceText(c) + "</span></button>";
  }
  function cardTile(c) {
    var img = KD.safeUrl(c.imageUrl);
    return '<button type="button" data-card="' + esc(c.id) + '" aria-label="' + esc(qty(c) + " " + c.name) + '">' +
      (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async">' : '<span class="noimg">' + esc(c.name) + "</span>") +
      (qty(c) > 1 ? '<span class="qty">' + qty(c) + "×</span>" : "") + "</button>";
  }

  function afterEdit(name, flashId) {
    paintHeader(); paintDeck(); paintStats(); refreshBadges(name); edited();
    if (flashId) {
      var row = KD.$$("[data-card]", $('[data-pane="deck"]')).find(function (x) { return x.dataset.card === String(flashId); });
      if (row) { row.classList.remove("is-flash"); void row.offsetWidth; row.classList.add("is-flash"); }
    }
  }

  function changeQty(card, delta) {
    var my = ctx;
    return enqueue(async function () {
      var next = (parseInt(card.quantity, 10) || 1) + delta;
      await D.setQty(my.deck.id, card, next);
      if (next <= 0) my.cards = my.cards.filter(function (c) { return c !== card; });
      if (ctx === my) afterEdit(card.name, next > 0 ? card.id : null);
    });
  }

  // ---- card sheets (the pieces come from lib/cardsheet.js, shared with the collection and the public pages)
  var cardImg = KD.cardx.img, cardInfo = KD.cardx.info, scryInfo = KD.cardx.scryInfo, buyBtn = KD.cardx.buyBtn;
  function ownBtn() { return '<button class="btn btn--ghost btn--sm" type="button" data-own>' + KD.icon("box") + "<span>Add to collection</span></button>"; }
  function bindOwn(el, card) {
    var b = KD.$("[data-own]", el);
    if (!b) return;
    b.addEventListener("click", async function () {
      b.disabled = true;
      try { await D.saveToCollection(card, 1); KD.toast("Added " + card.name + " to your collection.", "ok"); }
      catch (e) { console.error(e); KD.toast("Couldn't add it to your collection.", "err"); }
      b.disabled = false;
    });
  }

  function openCard(card) {
    var my = ctx;
    var canCmd = D.isCommanderFormat(my.deck.format) && (card.isCommander || D.canBeCommander(card, my.deck.format));
    var s = KD.sheet({
      title: esc(card.name), size: "lg",
      body: '<div class="cardx">' + cardImg(card.imageUrl, card.name) + '<div class="cardx__info">' + cardInfo(card) +
        '<div class="row row--wrap"><div class="qtyctl" role="group" aria-label="Copies in this deck">' +
          '<button class="iconbtn iconbtn--sm" type="button" data-q="-1" aria-label="One fewer">' + KD.icon("minus") + "</button>" +
          "<b data-qv>" + qty(card) + "</b>" +
          '<button class="iconbtn iconbtn--sm" type="button" data-q="1" aria-label="One more">' + KD.icon("plus") + "</button></div>" +
          (canCmd ? '<button class="btn btn--ghost btn--sm" type="button" data-cmd>' + KD.icon("crown") + "<span>" + (card.isCommander ? "Remove as commander" : "Make commander") + "</span></button>" : "") +
        "</div>" +
        '<div class="cardx__actions">' + buyBtn(card.name) + ownBtn() +
          '<button class="btn btn--danger btn--sm" type="button" data-rm>' + KD.icon("trash") + "<span>Remove</span></button></div>" +
      "</div></div>"
    });
    KD.$$("[data-q]", s.el).forEach(function (b) {
      b.addEventListener("click", function () {
        changeQty(card, parseInt(b.dataset.q, 10)).then(function () {
          if (ctx !== my || !findCard(card.id)) s.close();
          else KD.$("[data-qv]", s.el).textContent = qty(card);
        });
      });
    });
    KD.$("[data-rm]", s.el).addEventListener("click", function () {
      s.close();
      changeQty(card, -qty(card)).then(function () { if (ctx === my && !findCard(card.id)) KD.toast("Removed " + card.name + ".", "ok"); });
    });
    var cmd = KD.$("[data-cmd]", s.el);
    if (cmd) cmd.addEventListener("click", function () {
      var on = !card.isCommander;
      s.close();
      enqueue(async function () {
        await D.setCommander(my.deck.id, card, on);
        if (ctx === my) { afterEdit(card.name, card.id); KD.toast(on ? card.name + " now leads the deck." : card.name + " is no longer a commander.", "ok"); }
      });
    });
    bindOwn(s.el, card);
  }

  function openScry(sc) {
    if (!sc) return;
    var my = ctx, n = inDeck(sc.name);
    var s = KD.sheet({
      title: esc(sc.name), size: "lg",
      body: '<div class="cardx">' + cardImg(D.getCardImageUrl(sc), sc.name) + '<div class="cardx__info">' + cardInfo(scryInfo(sc)) +
        '<div class="row row--wrap"><button class="btn btn--lure btn--sm" type="button" data-add-one>' + KD.icon("plus") + "<span>Add to deck</span></button>" +
          '<span class="hint" data-indeck>' + (n ? n + " in this deck" : "") + "</span></div>" +
        '<div class="cardx__actions">' + buyBtn(sc.name) + ownBtn() + "</div>" +
      "</div></div>"
    });
    KD.$("[data-add-one]", s.el).addEventListener("click", function () {
      addFromSearch(sc, null).then(function () {
        if (ctx !== my) return;
        var c = inDeck(sc.name), el = KD.$("[data-indeck]", s.el);
        if (el) el.textContent = c ? c + " in this deck" : "";
      });
    });
    bindOwn(s.el, sc);
  }

  // ---- hover preview (mouse only)
  var PEEK_SEL = ".drow[data-card], .rrow[data-sid]";
  var fine = window.matchMedia("(hover: hover) and (pointer: fine)");
  var pop = null;
  function peek(e) {
    if (!ctx || !fine.matches) return;
    var row = e.target.closest(PEEK_SEL);
    if (row && e.target.closest("[data-add]")) { unpeek(); return; } // never cover the + button
    if (!row || row === ctx.peekRow) return;
    var url = row.dataset.card ? (findCard(row.dataset.card) || {}).imageUrl : D.getCardImageUrl(ctx.search.cache[row.dataset.sid] || {});
    url = KD.safeUrl(url);
    if (!url) return;
    ctx.peekRow = row;
    if (!pop) {
      pop = document.createElement("div");
      pop.className = "cpop";
      pop.setAttribute("aria-hidden", "true");
      pop.innerHTML = '<img alt="">';
      document.body.appendChild(pop);
    }
    var img = pop.firstChild;
    if (img.getAttribute("src") !== url) img.src = url;
    var r = row.getBoundingClientRect(), w = 236, h = Math.round(w * 680 / 488);
    // search results sit in the right-hand panel: show the card beside the panel, not over it
    var left = row.dataset.sid && r.left - w - 16 >= 10 ? r.left - w - 16 : e.clientX + 28;
    if (left + w > window.innerWidth - 10) left = e.clientX - w - 28;
    left = Math.max(10, left);
    var top = Math.max(10, Math.min(window.innerHeight - h - 10, r.top + r.height / 2 - h / 2));
    pop.style.left = left + "px";
    pop.style.top = top + "px";
    pop.classList.add("is-on");
  }
  function unpeek() {
    if (ctx) ctx.peekRow = null;
    if (pop) pop.classList.remove("is-on");
  }
  window.addEventListener("scroll", function () { if (pop && pop.classList.contains("is-on")) unpeek(); }, { passive: true });

  // ================================================================ stats

  function paintStats() {
    var host = $('[data-pane="stats"]');
    if (!host) return;
    var st = D.deckStats(ctx.cards), target = D.targetSize(ctx.deck.format);
    var max = Math.max.apply(null, st.curve.concat([1]));
    var curve = st.curve.map(function (n, i) {
      return "<div><b>" + (n || "") + '</b><i style="height:' + (n ? Math.max(5, Math.round(n / max * 66)) : 0) + '%"></i><em>' + (i === 7 ? "7+" : i) + "</em></div>";
    }).join("");
    var keys = ["W", "U", "B", "R", "G", "C"], total = keys.reduce(function (s, k) { return s + st.colors[k]; }, 0);
    var bar = total ? keys.filter(function (k) { return st.colors[k]; }).map(function (k) {
      return '<i style="width:' + (st.colors[k] / total * 100).toFixed(1) + "%;background:" + COLOR_HEX[k] + '" title="' + COLOR_NAME[k].replace(" only", "") + ": " + st.colors[k] + '"></i>';
    }).join("") : "";
    host.innerHTML = '<div><h4>Mana curve</h4><div class="curve" role="img" aria-label="Mana curve of the nonland cards">' + curve + "</div></div>" +
      "<div><h4>Colors</h4>" + (bar ? '<div class="colorbar">' + bar + "</div>" : '<div class="colorbar"></div>') +
      '<div class="facts">' +
        "<div><b>" + st.total + " / " + target + "</b>Cards</div>" +
        "<div><b>" + st.lands + "</b>Lands</div>" +
        "<div><b>" + (st.spells ? st.avgMv.toFixed(2) : "–") + "</b>Avg. mana value</div>" +
        "<div><b>" + (st.priced ? KD.money(st.price) : "–") + "</b>Est. value</div>" +
      "</div></div>";
  }

  // ================================================================ add cards

  function paintAdd() {
    var host = $('[data-pane="add"]');
    host.innerHTML = '<div class="addp__tabs"><div class="seg seg--block" role="tablist" aria-label="Ways to add cards">' +
      '<button type="button" role="tab" data-tool="search">' + KD.icon("search") + "<span>Search</span></button>" +
      '<button type="button" role="tab" data-tool="ai">' + KD.icon("sparkle") + "<span>AI build</span></button>" +
      '<button type="button" role="tab" data-tool="import">' + KD.icon("download") + "<span>Import</span></button>" +
      '</div></div><div class="addp__body" data-toolbody></div>';
    setTool(ctx.tool);
  }

  function setTool(t) {
    ctx.tool = t;
    $$("[data-tool]").forEach(function (b) { b.setAttribute("aria-selected", String(b.dataset.tool === t)); });
    paintTool();
  }

  function paintTool() {
    var body = $("[data-toolbody]");
    if (!body) return;
    if (ctx.tool === "ai") paintAi(body);
    else if (ctx.tool === "import") paintImport(body);
    else paintSearch(body);
  }

  // ---- search (Scryfall)
  var searchT = null;
  function runSearchSoon(ms) { clearTimeout(searchT); searchT = setTimeout(runSearch, ms == null ? 350 : ms); }

  function paintSearch(body) {
    var s = ctx.search, fmt = D.scryFormat(ctx.deck.format);
    body.innerHTML = '<div class="search">' +
      '<label class="inputwrap">' + KD.icon("search") +
        '<input class="input" type="search" data-sq value="' + esc(s.q) + '" placeholder="Card name, rules text or t:goblin" autocomplete="off" spellcheck="false" enterkeyhint="search" aria-label="Search cards"></label>' +
      '<div class="row row--wrap row--between">' +
        '<div class="colors" role="group" aria-label="Colors">' + ["W", "U", "B", "R", "G", "C"].map(function (c) {
          var on = s.colors.has(c);
          return '<button type="button" data-color="' + c + '" class="' + (on ? "is-on" : "") + '" aria-pressed="' + on + '" title="' + COLOR_NAME[c] + '">' + KD.mana("{" + c + "}") + "</button>";
        }).join("") + "</div>" +
        (fmt ? '<button type="button" class="chip' + (s.legal ? " is-on" : "") + '" data-legal aria-pressed="' + s.legal + '">' + KD.icon("check") + esc(D.formatLabel(ctx.deck.format)) + " legal</button>" : "") +
      "</div>" +
      '<div class="filters">' +
        '<select class="select" data-sf="type" aria-label="Card type"><option value="">Any type</option>' +
          TYPES.map(function (t) { return '<option value="' + t.toLowerCase() + '">' + t + "</option>"; }).join("") + "</select>" +
        '<select class="select" data-sf="mv" aria-label="Mana value"><option value="">Any cost</option><option value="mv<=1">MV 0–1</option><option value="mv=2">MV 2</option>' +
          '<option value="mv=3">MV 3</option><option value="mv=4">MV 4</option><option value="mv=5">MV 5</option><option value="mv>=6">MV 6+</option></select>' +
        '<select class="select" data-sf="sort" aria-label="Sort results"><option value="">Best match</option><option value="edhrec">Most played</option><option value="name">Name</option>' +
          '<option value="usd-desc">Price: high</option><option value="usd-asc">Price: low</option><option value="cmc">Mana value</option></select>' +
      "</div>" +
      '<div class="results" data-results aria-live="polite"></div></div>';
    KD.$$("[data-sf]", body).forEach(function (sel) {
      sel.value = s[sel.dataset.sf] || "";
      sel.addEventListener("change", function () { s[sel.dataset.sf] = sel.value; if (s.q.trim()) runSearchSoon(0); });
    });
    var input = KD.$("[data-sq]", body);
    input.addEventListener("input", function () { s.q = input.value; runSearchSoon(); });
    input.addEventListener("keydown", function (e) {
      if (e.key !== "Enter") return;
      e.preventDefault();
      runSearchSoon(0);
      if (KD.mobile()) input.blur();
    });
    if (s.q.trim() && s.buf.length) renderResults(true);
    else if (s.q.trim()) runSearch();
    else idle();
  }

  function idle() {
    var box = $("[data-results]");
    if (!box) return;
    var s = ctx.search;
    var note = s.colors.size && !s.colorsTouched && D.isCommanderFormat(ctx.deck.format) ? '<p class="hint">Showing cards in your commander’s colors. Tap a color to change it.</p>' : "";
    box.innerHTML = '<div class="stack" style="padding:10px 2px">' +
      '<p class="hint">Search every Magic card by name or rules text, or start from a staple:</p>' +
      '<div class="presets">' + PRESETS.map(function (p, i) { return '<button type="button" class="chip" data-preset="' + i + '">' + esc(p.label) + "</button>"; }).join("") + "</div>" +
      note + "</div>";
  }

  function toggleColor(c) {
    var s = ctx.search;
    s.colorsTouched = true;
    if (c === "C") s.colors = new Set(s.colors.has("C") ? [] : ["C"]);
    else { s.colors.delete("C"); if (s.colors.has(c)) s.colors.delete(c); else s.colors.add(c); }
    $$("[data-color]").forEach(function (b) { var on = s.colors.has(b.dataset.color); b.classList.toggle("is-on", on); b.setAttribute("aria-pressed", String(on)); });
    if (s.q.trim()) runSearchSoon(0); else idle();
  }

  function buildQuery() {
    var s = ctx.search, parts = [s.q.trim()];
    if (s.colors.size) parts.push(s.colors.has("C") ? "id=c" : "id<=" + Array.from(s.colors).join(""));
    if (s.type) parts.push("t:" + s.type);
    if (s.mv) parts.push(s.mv);
    var f = D.scryFormat(ctx.deck.format);
    if (s.legal && f) parts.push("legal:" + f);
    return parts.filter(Boolean).join(" ");
  }

  async function runSearch() {
    var my = ctx;
    if (!my || !my.root) return;
    var s = my.search, box = $("[data-results]");
    if (!box) return;
    if (!s.q.trim()) { s.token++; s.buf = []; s.shown = 0; s.next = null; idle(); return; }
    var token = ++s.token;
    box.innerHTML = new Array(7).join('<div class="rskel skel"></div>');
    try {
      var r = await D.scrySearch(buildQuery(), s.sort);
      if (ctx !== my || token !== s.token) return;
      s.buf = r.data; s.next = r.next; s.total = r.total; s.cache = {};
      renderResults(false);
    } catch (e) {
      if (ctx !== my || token !== s.token) return;
      var b = $("[data-results]");
      if (b) b.innerHTML = '<div class="empty">' + KD.icon("alert") + "<p>" +
        (/Scryfall 400/.test(e.message || "") ? "Scryfall couldn't read that search. Try plainer words." : "Search failed. Check your connection and try again.") + "</p></div>";
    }
  }

  function renderResults(restore) {
    var s = ctx.search, box = $("[data-results]");
    if (!box) return;
    var upto = restore ? Math.max(40, s.shown) : 40;
    s.shown = 0;
    if (!s.buf.length) {
      var filtered = s.colors.size || s.type || s.mv;
      box.innerHTML = '<div class="empty">' + KD.icon("search") + "<p>No cards match" + (filtered ? " with those filters" : "") + ".</p></div>";
      return;
    }
    box.innerHTML = '<p class="results__meta">' + KD.fmt(s.total) + " " + KD.plural(s.total, "card") + "</p>";
    more(upto);
  }

  function more(n) {
    var s = ctx.search, box = $("[data-results]");
    if (!box) return;
    var old = KD.$("[data-more]", box);
    if (old) old.remove();
    var slice = s.buf.slice(s.shown, s.shown + n);
    slice.forEach(function (c) { s.cache[c.id] = c; });
    box.insertAdjacentHTML("beforeend", slice.map(resultRow).join(""));
    s.shown += slice.length;
    if (s.shown < s.buf.length) box.insertAdjacentHTML("beforeend", '<button class="btn btn--ghost btn--sm btn--block mt-8" type="button" data-more>Show ' + Math.min(40, s.buf.length - s.shown) + " more</button>");
    else if (s.next) box.insertAdjacentHTML("beforeend", '<button class="btn btn--ghost btn--sm btn--block mt-8" type="button" data-more="page">Load more cards</button>');
  }

  async function loadMore(btn) {
    var my = ctx, s = my.search;
    if (btn.dataset.more !== "page") { more(40); return; }
    btn.disabled = true;
    btn.textContent = "Loading…";
    try {
      var r = await D.scryNext(s.next);
      if (ctx !== my) return;
      s.buf = s.buf.concat(r.data); s.next = r.next;
      more(40);
    } catch (e) { btn.disabled = false; btn.textContent = "Couldn't load. Tap to retry"; }
  }

  function resultRow(c) {
    var face = (c.card_faces && c.card_faces[0]) || c;
    var img = KD.safeUrl(D.artUrl(D.getCardImageUrl(c)));
    var n = inDeck(c.name);
    var type = String(c.type_line || "").split("//")[0].split("—")[0].trim();
    return '<div class="rrow" data-sid="' + esc(c.id) + '">' +
      (img ? '<img class="rrow__thumb" src="' + esc(img) + '" alt="" loading="lazy" decoding="async" data-peek>' : '<span class="rrow__thumb" data-peek></span>') +
      '<div class="rrow__main" data-peek role="button" tabindex="0" aria-label="' + esc(c.name) + ' details">' +
        '<div class="rrow__name"><span>' + esc(c.name) + '</span><b class="rrow__in" data-in="' + esc(c.name) + '"' + (n ? "" : " hidden") + ">" + (n ? n + " in deck" : "") + "</b></div>" +
        '<div class="rrow__meta">' + KD.mana(frontCost(c.mana_cost || face.mana_cost)) + "<span>" + esc(type) + "</span>" +
          (c.prices && c.prices.usd ? '<span class="mono">$' + esc(c.prices.usd) + "</span>" : "") + "</div></div>" +
      '<button class="addbtn" type="button" data-add aria-label="Add ' + esc(c.name) + ' to the deck">' + KD.icon("plus") + "</button></div>";
  }

  function refreshBadges(name) {
    $$("[data-in]").forEach(function (b) {
      if (name && b.dataset.in !== name) return;
      var n = inDeck(b.dataset.in);
      b.hidden = !n;
      b.textContent = n ? n + " in deck" : "";
    });
  }

  function addFromSearch(sc, btn) {
    if (!sc) return Promise.resolve();
    var my = ctx;
    if (btn) {
      btn.classList.add("is-done");
      btn.innerHTML = KD.icon("check");
      clearTimeout(btn._t);
      btn._t = setTimeout(function () { btn.classList.remove("is-done"); btn.innerHTML = KD.icon("plus"); }, 900);
    }
    return enqueue(async function () {
      var card = await D.addToDeck(my.deck.id, my.cards, sc);
      if (ctx === my) afterEdit(card.name, card.id);
    });
  }

  // ---- AI: improve this deck (keeps it) or rebuild it from scratch
  // 2026-10-03: a deck with cards opens on Improve — the swaps flow in 55-improve.js. Rebuild is the
  // old whole-deck generation.
  function openImprove(preset) {
    if (!ctx) return;
    ctx.aiMode = "improve";
    ctx.improvePreset = preset || null;
    setTab("add");
    setTool("ai");
  }
  function paintAi(body) {
    var my = ctx, n = D.deckStats(my.cards).total;
    if (!my.aiMode) my.aiMode = n >= 10 && !B.retry ? "improve" : "rebuild";
    if (n >= 10 || (n > 0 && my.aiMode === "improve")) {
      body.innerHTML = '<div class="seg seg--block aimode" role="tablist" aria-label="What the AI does">' +
        '<button type="button" role="tab" data-aimode="improve" aria-selected="' + (my.aiMode === "improve") + '">' + KD.icon("wand") + "<span>Improve this deck</span></button>" +
        '<button type="button" role="tab" data-aimode="rebuild" aria-selected="' + (my.aiMode === "rebuild") + '">' + KD.icon("refresh") + "<span>Rebuild from scratch</span></button></div>" +
        '<div data-aimode-body class="mt-16"></div>';
      KD.$$("[data-aimode]", body).forEach(function (b) {
        b.addEventListener("click", function () { my.aiMode = b.dataset.aimode; paintAi(body); });
      });
      var inner = KD.$("[data-aimode-body]", body);
      if (my.aiMode === "improve") {
        var preset = my.improvePreset; my.improvePreset = null;
        KD.improve.paint(inner, { deck: my.deck, cards: my.cards, preset: preset });
        return;
      }
      body = inner;
    }
    var prompt = B.retry ? B.retry.prompt : "";
    B.retry = null;
    body.innerHTML = "<div data-aiform></div>" +
      (n ? '<div class="nudge mt-16">' + KD.icon("info") + "A build replaces the " + n + " " + KD.plural(n, "card") + " in this deck. To keep them, start a " +
        '<button class="linkbtn" type="button" data-create>new deck</button> instead.</div>' : "") +
      "<div data-nudge></div>" +
      '<button class="btn btn--lure btn--block mt-16" type="button" data-ai-go>' + KD.icon("sparkle") + "<span>" + (n ? "Rebuild with AI" : "Build it with AI") + "</span></button>" +
      '<p class="gensline mt-8" data-gensline style="justify-content:center"></p>' +
      '<p class="hint mt-8" style="text-align:center">Want feedback on a list instead? <button class="linkbtn" type="button" data-act="analyze">Analyze it</button></p>';
    var form = KD.aiForm(KD.$("[data-aiform]", body), { format: my.deck.format, deckId: my.deck.id, prompt: prompt });
    KD.paintGensLine(KD.$("[data-gensline]", body));
    if (prompt) setTimeout(function () { form.focus(); }, 60);
    KD.$("[data-ai-go]", body).addEventListener("click", async function () {
      var r = form.read();
      if (!r.prompt) { form.focus(); KD.toast("Describe the deck you want first.", "info"); return; }
      if (D.reviewIntent(r.prompt) && !my.nudged) {
        my.nudged = true;
        var host = KD.$("[data-nudge]", body);
        host.innerHTML = '<div class="nudge mt-16">' + KD.icon("info") + (my.cards.length >= 10
            ? "Sounds like you want to improve this deck, not replace it. <b>Improve this deck</b> keeps your cards and suggests swaps you can pick from."
            : "Sounds like you want feedback on a deck you already have. Paste your list with <b>Import</b>, then use <b>Improve this deck</b> to get swaps you can pick from.") +
          '<div class="nudge__actions">' + (my.cards.length >= 10
            ? '<button class="btn btn--lure btn--sm" type="button" data-nudge-improve>' + KD.icon("wand") + "Improve this deck</button>"
            : '<button class="btn btn--ghost btn--sm" type="button" data-tool-go="import">' + KD.icon("download") + "Paste my list</button>") +
          '<button class="btn btn--ghost btn--sm" type="button" data-nudge-skip>No, build me a new deck</button></div></div>';
        var ni = KD.$("[data-nudge-improve]", host);
        if (ni) ni.addEventListener("click", function () { openImprove({ goal: r.prompt }); });
        KD.$("[data-nudge-skip]", host).addEventListener("click", function () { host.innerHTML = ""; go(r); });
        host.scrollIntoView({ block: "nearest", behavior: KD.reduce ? "auto" : "smooth" });
        return;
      }
      go(r);
    });
    async function go(r) {
      var have = D.deckStats(my.cards).total;
      if (have) {
        var ok = await KD.confirm({ title: "Rebuild this deck?", body: "<p>The Kraken builds a fresh list and replaces the " + have + " " + KD.plural(have, "card") + " here. This can't be undone.</p>", confirm: "Rebuild it" });
        if (!ok || ctx !== my) return;
      }
      KD.create.start(r, my.deck);
    }
  }

  // ---- import a list into this deck
  function paintImport(body) {
    body.innerHTML = '<p class="hint">One card per line, like “4 Lightning Bolt”. Exports from Moxfield, Archidekt, MTG Arena and CSV files all work, and cards already in the deck just get their count raised.</p>' +
      '<textarea class="textarea mt-8" data-imp style="min-height:220px" placeholder="1 Sol Ring&#10;1 Arcane Signet&#10;4 Llanowar Elves" aria-label="Decklist to import"></textarea>' +
      '<button class="btn btn--lure btn--block mt-16" type="button" data-imp-go>' + KD.icon("download") + "<span>Add to deck</span></button>";
    KD.$("[data-imp-go]", body).addEventListener("click", function () {
      var ta = KD.$("[data-imp]", body);
      var parsed = D.parseListText(ta.value);
      if (!parsed.entries.length) { ta.focus(); KD.toast("No cards found in that list.", "info"); return; }
      runImport(parsed).then(function (ok) { if (ok) ta.value = ""; });
    });
  }

  async function runImport(parsed) {
    var my = ctx;
    if (!parsed.entries.length) { KD.toast("No cards found in that list.", "info"); return false; }
    KD.busy("Matching " + parsed.entries.length + " " + KD.plural(parsed.entries.length, "line") + "…");
    var res;
    try {
      var r = await D.resolveCardNames(parsed.entries.map(function (e) { return e.name; }), function (done, total) {
        KD.busyText("Matching card names… " + done + " of " + total);
      });
      KD.busyText("Adding cards…");
      await my.q;
      res = await D.importToDeck(my.deck.id, parsed.entries, r.resolved, my.cards);
    } catch (e) {
      console.error("deck import", e);
      KD.idle();
      KD.toast("The import failed while saving, so the deck may be partly updated. Try again.", "err");
      await reloadCards(my);
      return false;
    }
    KD.idle();
    await reloadCards(my);
    // 2026-10-03: a commander list that didn't mark its commander gets the legend whose colors cover
    // the deck (imports used to leave every deck without one)
    if (ctx === my && D.isCommanderFormat(my.deck.format) && !my.cards.some(function (c) { return c.isCommander; })) {
      var guess = D.guessCommander(my.cards, my.deck.format);
      if (guess) {
        try { await D.setCommander(my.deck.id, guess, true); if (ctx === my) paintAll(); KD.toast(guess.name + " leads this deck. Change it from the card if that's wrong.", "info"); }
        catch (e) { /* the player can set it from the card */ }
      }
    }
    if (ctx === my) { edited(); setTab("deck"); }
    KD.importReport({ what: "this deck", matchedLines: res.matchedLines, totalLines: parsed.entries.length - (res.sideLines || []).length, importedQty: res.importedQty, unmatchedLines: res.unmatchedLines, sideLines: res.sideLines });
    return true;
  }

  async function reloadCards(my) {
    try { my.cards = await D.getDeckCards(my.deck.id); } catch (e) { /* keep what we have */ }
    if (ctx === my) paintAll();
  }

  // Shared with the collection importer: a toast when everything matched, a sheet listing the
  // lines that didn't (so nothing is dropped silently).
  KD.importReport = function (o) {
    var miss = o.unmatchedLines || [], skipped = (o.skipped || []).length, side = (o.sideLines || []).length;
    var skipNote = (skipped ? " Skipped " + skipped + " " + KD.plural(skipped, "line") + " that weren't cards, like section headers." : "") +
      (side ? " Left out " + side + " sideboard " + KD.plural(side, "line") + "." : "");
    if (!miss.length) { KD.toast("Added " + KD.fmt(o.importedQty) + " " + KD.plural(o.importedQty, "card") + " to " + o.what + "." + skipNote, "ok"); return; }
    var s = KD.sheet({
      title: "Imported " + o.matchedLines + " of " + o.totalLines + " " + KD.plural(o.totalLines, "line"),
      body: '<p class="hint">' + KD.fmt(o.importedQty) + " " + KD.plural(o.importedQty, "card was", "cards were") + " added to " + esc(o.what) + "." + esc(skipNote) + " " +
        (miss.length === 1 ? "This line didn't" : "These " + miss.length + " lines didn't") + " match a card name, so " + (miss.length === 1 ? "it was" : "they were") + " skipped:</p>" +
        '<textarea class="textarea mt-8" readonly style="min-height:140px" aria-label="Lines that did not match">' + esc(miss.join("\n")) + "</textarea>" +
        '<p class="hint mt-8">Fix the spelling and import just those lines again.</p>',
      foot: '<button class="btn btn--ghost" type="button" data-copy-miss>' + KD.icon("copy") + "Copy lines</button>" +
        '<button class="btn btn--lure" type="button" data-close>Done</button>'
    });
    KD.$("[data-copy-miss]", s.el).addEventListener("click", function () { KD.copy(miss.join("\n"), "Lines copied."); });
  };

  // ================================================================ after an AI build

  function buildNotes(data) {
    var notes = [], n;
    if (data.legalityNotice) notes.push(data.legalityNotice);
    if (data.retryVariation) notes.push("Same request as last time, so the Kraken built you a different take.");
    if (data.customKeyRejected) notes.push("Your own OpenAI key was rejected, so this deck was built with the site's engine.");
    if (Array.isArray(data.excludedApplied) && (n = data.excludedApplied.length)) notes.push("Kept " + n + " excluded " + KD.plural(n, "card") + " out of the deck.");
    if (data.excludeNote) notes.push(data.excludeNote);
    if (Array.isArray(data.includesApplied) && (n = data.includesApplied.length)) notes.push("Locked in " + n + " must-include " + KD.plural(n, "card") + ".");
    if (data.includeNote) notes.push(data.includeNote);
    if (data.formatNote) notes.push(data.formatNote);
    if (data.commanderNote) notes.push(data.commanderNote);
    if (data.partnerNote && data.partnerNote !== data.commanderNote) notes.push(data.partnerNote);
    if (data.usedCollection) notes.push("Built from your collection. Basic lands are added as needed, since everyone has those.");
    if (data.partner && data.commander) notes.push("Partner commanders: " + data.commander + " and " + data.partner + ".");
    if (data.budgetNote) notes.push(data.budgetNote);
    return notes.map(String);
  }

  function strip(o) {
    return '<div class="strip' + (o.kind ? " strip--" + o.kind : "") + '"' + (o.upsell ? " data-upsell" : "") + ' role="status">' +
      '<div class="strip__text"><b>' + o.title + "</b><p>" + o.text + "</p>" +
      (o.notes.length ? '<ul class="strip__notes">' + o.notes.map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + "</ul>" : "") + "</div>" +
      (o.cta || "") +
      '<button class="iconbtn iconbtn--sm" type="button" data-strip-x aria-label="Dismiss">' + KD.icon("x") + "</button></div>";
  }

  function showResult(res) {
    var host = $("[data-strip]");
    if (!host) return;
    var data = res.data || {}, notes = buildNotes(data);
    var meta = data.searchUsed ? " Built from this week’s meta." : "";
    var html;
    if (res.floodHeld) {
      html = strip({ kind: "info", title: "Saved as a draft", notes: notes,
        text: "That binder was a small pool, so the deck came out mostly basic lands. It stays private for now: add cards to the binder or build from your whole collection, then publish." });
    } else if (!S.isPremium && !upsellQuiet()) {
      var g = D.gens();
      var left = g.left > 0 ? "You have <b>" + g.left + " free " + KD.plural(g.left, "build") + " left this week</b>" : "That was <b>this week’s free build</b>";
      html = strip({ upsell: true, title: "Deck complete. Nice brew.", notes: notes,
        text: (res.published ? "It’s live in the public gallery. " : "") + left + ". Kraken Pro makes it unlimited, and adds the in-game Arena coach." + meta,
        cta: '<button class="btn btn--gold btn--sm" type="button" data-checkout="pro" data-upsell-go>Go Pro · $4.99/mo</button>' });
      KD.ga("success_upsell_shown");
    } else if (!S.isPremium) {
      html = strip({ kind: "info", title: "Deck complete", notes: notes,
        text: (res.published ? "It’s live in the public gallery." : "Publish it when you’re ready to share it.") + meta });
    } else {
      html = strip({ kind: "info", title: "Deck complete", notes: notes, text: "It’s private until you publish it." + meta,
        cta: '<button class="btn btn--ghost btn--sm" type="button" data-act="publish">' + KD.icon("globe") + "<span>Publish</span></button>" });
    }
    var refine = '<div class="refine" role="group" aria-label="Refine this deck"><span class="label">Refine it</span>' +
      [["removal", "More removal"], ["cheaper", "Cheaper"], ["stronger", "Stronger"], ["curve", "Lower curve"], ["weak", "Upgrade weak cards"]].map(function (x) {
        return '<button type="button" class="chip" data-refine="' + x[0] + '">' + x[1] + "</button>";
      }).join("") + "</div>";
    host.innerHTML = html + refine;
    KD.$$("[data-refine]", host).forEach(function (b) {
      b.addEventListener("click", function () { KD.ga("refine_chip", { goal: b.dataset.refine }); openImprove({ goals: [b.dataset.refine] }); });
    });
  }
})();
